import React from 'react';
import FormInputSearch from './FormInputSearchItem';
import AccountSearch from '../../search/AccountSearch';

export default function FormInputAccountSearch(props) {
  return <FormInputSearch {...props} searchComponent={AccountSearch} />;
}
